module.exports = __webpack_public_path__ + "img/diapositiva-4-1.5f0f11da.png";